import React from 'react';
import CustomerHeader from '../../app/customer/components/CustomerHeader/page';
import { useSelector } from 'react-redux';
import dynamic from 'next/dynamic';
const Header = dynamic(() => import("../../app/components/Header/page"), {
    ssr: false,
});

const MainHeader = () => {
    const token = useSelector((store) => store?.auth?.user?.accessToken);
    return (
        <>
            {token ?
                <CustomerHeader />
                :
                <Header />
            }
        </>
    )
}

export default MainHeader
